import {
    DependencyList, useCallback, useEffect,
    useRef,
} from "react";

export type Handler = (...args: any[]) => any | undefined;

export default function useChangingCallback<T extends Handler>(handler: T, dependencies: DependencyList) {
    const handlerRef = useRef<T>();
    useEffect(() => {
        handlerRef.current = handler;
    }, dependencies);
    return useCallback<T>(((...args) => handlerRef.current?.(...args)) as T, []);
}

export function useChangingHandler<T extends Handler>(handler: T) {
    return useChangingCallback(handler, [handler]);
}
